import { getNoAuth } from '../../../api/Api';

export const getProductsFromQuery = (query) => getNoAuth(`products?search=${query}`);
